export default async () => {
  const controller = await import(
    /* webpackChunkName: "KENCompareController-lib" */ '@/kenwood/Controllers/Listing/KenwoodCompareController'
  );
  controller.default();
};
